import { useCallback, useMemo } from "react";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import {
  selectInstanceThreads,
  selectSelectedInstanceThread,
} from "../../redux/selectors";
import { TDeerFlowThread } from "../../../../services/api/instances/deerflowApi/types";
import { clearMessages, setSelectedInstanceThread } from "../../redux/slice";
import { GenericSelect } from "../../../../shared/components/AppGenericSelect";
import { getDeerFlowThreadMessages } from "../../redux/actions";
import styles from "./styles.module.css";

interface Props {
  isDisabled: boolean;
  className?: string;
}

export const InstanceThreadsSelect = ({ isDisabled, className }: Props) => {
  const dispatch = useAppDispatch();
  const instanceThreads = useAppSelector(selectInstanceThreads);
  const selectedInstanceThread = useAppSelector(selectSelectedInstanceThread);

  const threads = useMemo(() => {
    return instanceThreads;
  }, [instanceThreads]);

  const handleSelectInstanceThread = useCallback(
    (thread: TDeerFlowThread | null) => {
      dispatch(clearMessages());
      dispatch(setSelectedInstanceThread(thread));
      if (thread) {
        dispatch(getDeerFlowThreadMessages(thread));
      }
    },
    [instanceThreads],
  );

  return (
    <GenericSelect<TDeerFlowThread>
      options={threads}
      value={selectedInstanceThread}
      onChange={handleSelectInstanceThread}
      getLabel={(thread) => thread.values.title}
      getValue={(thread) => thread.thread_id}
      placeholder={"Выберите тред"}
      className={styles["thread-select"]}
      isDisabled={isDisabled && threads.length === 0}
    />
  );
};
